module.exports = __webpack_public_path__ + "img/right-arrow.07586b6b.svg";